import { makeStyles } from 'tss-react/mui';

export const useReferralCodeButtonStyles = makeStyles()(() => ({
  root: {
    whiteSpace: 'nowrap',
  },
}));
